import type { ICreateDownloadReport, IGetDownloadReportListParams } from 'core/model/interfaces/downloads-uploads';
import { downloadsData } from './downloads.data';
import { toCreateDownloadReportParams, toDownloadReportList, toGetDownloadReportListParams } from './downloads.mappers';

export const downloadsService = {
  getDownloadReportListByReportType: async (values: IGetDownloadReportListParams) => {
    const params = toGetDownloadReportListParams(values);

    const response = await downloadsData.getDownloadReportListByReportType(params);

    return toDownloadReportList(response);
  },
  createDownloadReport: async (params: ICreateDownloadReport) => {
    const paramsDto = toCreateDownloadReportParams(params);

    const response = await downloadsData.createDownloadReport(paramsDto);

    return response;
  },
};
